import { Position } from "geojson";
import { logEvent } from "./logEvent";
import { PlanningTypesFilters } from "react-migration/domains/planning/types";

export type LogEventCreatedSiteEventLocation =
  | "SearchResultItem"
  | "PlanningResultActions"
  | "PropertyValueLayout"
  | "OwnershipSearchSidebar"
  | "SelectionView";
export type LogEventV2Props =
  | {
      name: "Isochrone Layer Map click";
      properties: {
        lng: string;
        lat: string;
        zoom: number;
        routingType: string;
        routingTime: string;
      };
    }
  | {
      name: "Constraints Layer Map click";
      properties: {
        lng: string;
        lat: string;
        zoom: number;
        visibleCategories: string[];
        hiddenStatuses: string[];
      };
    }
  | {
      name: "Constraints Category Toggled";
      properties: {
        category_id: string;
        selected: boolean;
        group_category: string;
      };
    }
  | {
      name: "Planning map click";
      properties: {
        Residential: boolean;
        Commercial: boolean;
        Other: boolean;
        "Max Year": number;
        "Min Size": number;
        "Map Zoom": number;
        "Enabled statuses": string[];
        "Selection coordinate": Position | undefined;
        "Type filter": PlanningTypesFilters;
        boundaryViewEnabled: boolean;
      };
    }
  | {
      name: "Navigation";
      properties: {
        route: string;
      };
    }
  | {
      name: "Designations list filter";
      properties: {
        text: string;
      };
    }
  | {
      name: "Bundle Map Click";
      properties: {
        bundleId: string;
        visibleLayerIds: string;
        selectionLayerId: string;
      };
    }
  | {
      name: "Created site";
      properties: {
        source: string;
        eventLocation: LogEventCreatedSiteEventLocation;
        zoom?: number;
        idToSave?: string;
        mapType?: string;
        searchId?: string;
      };
    }
  | {
      name: "Created sites";
      properties: {
        source: string;
        eventLocation: LogEventCreatedSiteEventLocation;
        zoom?: number;
        idToSave?: string;
        mapType?: string;
        searchId?: string;
        sitesSavedCount?: number;
      };
    }
  | {
      name: "Toggle layer visibility";
      properties: {
        layerId: string;
        constraint_layer: string;
        visible: boolean;
        onlyThisLayer?: boolean;
      };
    }
  | {
      name: "Sites layer button click";
      properties: {
        type: "share" | "edit" | "save" | "update" | "delete";
      };
    }
  | {
      name: "Intersections click";
      properties: {
        layerId: string;
      };
    }
  | {
      name: "Ownership Views Run Out";
      properties: {
        views: number;
        cap: number;
        hasHitCap: boolean;
      };
    }
  | {
      name: "Parcel click";
      properties: {
        tenure?: string;
        zoom: string;
        titleID?: string;
        country?: string;
        lat?: number;
        lng?: number;
      };
    }
  | {
      name: "Selection Detail - Back Button Click";
      properties: {
        detailSelectionType?: string;
        detailSelectionId?: string;
      };
    }
  | {
      name: "Planning authority layer filtering";
      properties: {
        presumptionInFavour: boolean;
      };
    };

export const logEventV2 = ({ name, properties }: LogEventV2Props) => logEvent(name, properties);
